import Styled from 'styled-components';

export default Styled.label`
    font-weight: ${(p) => p.theme.fontWeights.bold};
    display: block;
    line-height: 1rem;
    padding-bottom: .5rem;
    padding-top: .5rem;
`;
